import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';

import { Observable } from 'rxjs';
import { Router } from '@angular/router';
import { tap } from 'rxjs/operators';
import { AuthenticationService } from '@core/services/authentication.service';
import { isHostedInWin } from '@core/win-bridge/win.utils';

@Injectable({
  providedIn: 'root',
})
export class CustomHttpInterceptor implements HttpInterceptor {
  constructor(
    private router: Router,
    private ngZone: NgZone,
    private authService: AuthenticationService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap({
        // Succeeds when there is a response; ignore other events
        next: () => {
          return;
        },
        // Operation failed; error is an HttpErrorResponse
        error: (error) => {
          switch (error.status) {
            case 401: {
              if (isHostedInWin() && this.authService.drk) {
                this.authService.drk = null;
              }
              this.navigateTo(`/login`);
              break;
            }
            case 403: {
              this.navigateTo(`/login`);
              break;
            }
          }
        },
      }),
    );
  }

  navigateTo(url: string): void {
    this.ngZone.run(() => {
      this.router.navigate([url]);
    });
  }
}
